import React, { useState, useEffect } from "react";

const FilterShops = ({ results, setFilteredResults }) => {
  // console.log("results filter shops", results);

  const [filters, setFilters] = useState({
    hasContactologia: false,
  });

  const [isOpen, setIsOpen] = useState(false);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: checked,
    }));
  };

  const toggleOpen = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (!results || results.length === 0) {
      setFilteredResults([]);
      return;
    }

    let filteredData = results;

    // Si el filtro "hasContactologia" está activado, aplicamos el filtro
    if (filters.hasContactologia) {
      filteredData = results.filter((shop) =>
        shop.servicio?.some(
          (servicio) =>
            servicio.tpc_denominacion?.toUpperCase() === "CONTACTOLOGIA"
        )
      );
    }
    // console.log( "Datos ya filtrados" , filteredData)

    // Si el filtro "hasContactologia" no está activado, se muestran todos los resultados
    setFilteredResults(filteredData);
  }, [filters, results, setFilteredResults]);

  return (
    <div className="filter-container">
      {/* Botón para abrir/cerrar el filtro */}
      <div className="col-12 store-filter">
        <p className="mb0 filter-button cpointer" onClick={toggleOpen}>
          <i className="fa fa-filter"></i> Filtrar resultados
          <span className={` ${isOpen ? "reset-deg" : ""}`}>
            <i className="fa fa-angle-down fa-lg"></i>
          </span>
        </p>
      </div>

      {/* Opciones de filtro desplegables */}
      <div className={`col-12 store-filter-options ${isOpen ? "" : "collapse"}`}>
        <label className="cpointer">
          <input
            type="checkbox"
            name="hasContactologia"
            checked={filters.hasContactologia}
            onChange={handleCheckboxChange}
          />
          Contactología
        </label>
      </div>
    </div>
  );
};

export default FilterShops;
